<template>
  <PartnersLayout>
    <template #header>
      <PartnersHeader
        title="팝업 광고 신청"
        subtitle="앱 진입 시 바텀시트로 노출되는 광고입니다"
      />
    </template>

    <div class="px-4 lg:px-6 pb-6">
      <div class="max-w-6xl mx-auto">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <!-- 왼쪽: 안내 및 바로가기 -->
          <div class="lg:col-span-1 space-y-4">
            <!-- 안내 카드 -->
            <div class="bg-white rounded-2xl border border-slate-200 p-5">
              <div class="flex items-center gap-2 mb-3">
                <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                  <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <h3 class="font-semibold text-slate-800">팝업 광고 안내</h3>
              </div>
              <ul class="text-sm text-slate-600 space-y-2">
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>광고 등록은 <strong class="text-blue-700">무료</strong>입니다</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>신청 후 <strong class="text-blue-700">관리자 승인</strong>이 필요합니다</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>광고 기간은 <strong class="text-blue-700">1주일</strong>입니다</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>계정당 <strong class="text-blue-700">1개</strong>만 등록 가능</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>광고 유입 콜은 <strong class="text-blue-700">건당 10,000P</strong>에 구매</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>앱 진입 시 <strong class="text-blue-700">바텀시트</strong>로 노출</span>
                </li>
              </ul>
            </div>

            <!-- 바로가기 -->
            <div class="bg-white rounded-2xl border border-slate-200 p-5">
              <h3 class="font-semibold text-slate-800 mb-3">바로가기</h3>
              <div class="space-y-2">
                <router-link
                  to="/partners/popup/my"
                  class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition group"
                >
                  <div class="w-9 h-9 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-slate-700">내 팝업 광고</p>
                    <p class="text-xs text-slate-500">신청 현황 확인</p>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link
                  to="/partners/ad/create"
                  class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition group"
                >
                  <div class="w-9 h-9 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-slate-700">캠페인 만들기</p>
                    <p class="text-xs text-slate-500">광고에 필요한 캠페인 생성</p>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
              </div>
            </div>
          </div>

          <!-- 오른쪽: 메인 콘텐츠 -->
          <div class="lg:col-span-2">
            <!-- 로딩 -->
            <div v-if="loading" class="bg-white rounded-2xl border border-slate-200 p-12 flex items-center justify-center">
              <div class="spinner"></div>
            </div>

            <!-- 이미 신청한 경우 -->
            <div v-else-if="hasExisting" class="bg-white rounded-2xl border border-slate-200 p-8 text-center">
              <div class="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg class="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-slate-800 mb-2">이미 신청한 광고가 있습니다</h3>
              <p class="text-slate-500 mb-6">대기 중이거나 승인된 팝업 광고가 있습니다.</p>
              <router-link
                to="/partners/popup/my"
                class="inline-flex items-center gap-2 px-6 py-3 bg-blue-500 text-white rounded-xl hover:bg-blue-600 transition"
              >
                내 팝업 광고 확인
              </router-link>
            </div>

            <!-- 캠페인 없는 경우 -->
            <div v-else-if="campaigns.length === 0" class="bg-amber-50 border border-amber-200 rounded-2xl p-6">
              <div class="flex items-center gap-3">
                <svg class="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
                <div>
                  <p class="font-semibold text-amber-800">활성화된 캠페인이 없습니다</p>
                  <p class="text-sm text-amber-600">팝업 광고를 등록하려면 먼저 캠페인을 생성해주세요.</p>
                  <router-link to="/partners/ad/create" class="inline-flex items-center gap-1 mt-2 text-sm text-blue-600 font-medium hover:underline">
                    캠페인 만들기
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                    </svg>
                  </router-link>
                </div>
              </div>
            </div>

            <!-- 신청 폼 -->
            <div v-else class="space-y-4">
              <!-- 캠페인 선택 -->
              <div class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-4">1. 캠페인 선택</h2>

                <div class="space-y-3">
                  <label
                    v-for="campaign in campaigns"
                    :key="campaign.id"
                    :class="[
                      'flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition',
                      selectedCampaign?.id === campaign.id
                        ? 'border-blue-500 bg-blue-50'
                        : 'border-slate-200 hover:border-blue-300'
                    ]"
                  >
                    <input
                      type="radio"
                      :value="campaign"
                      v-model="selectedCampaign"
                      class="w-5 h-5 text-blue-600"
                    />
                    <div class="flex-1">
                      <h3 class="font-semibold text-slate-800">{{ campaign.propertyName }}</h3>
                      <p class="text-sm text-slate-500">캠페인 코드: {{ campaign.code }}</p>
                      <p class="text-xs text-slate-400 mt-1">만료일: {{ campaign.endDate }}</p>
                    </div>
                    <span class="px-3 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full">
                      활성
                    </span>
                  </label>
                </div>
              </div>

              <!-- 시간대 선택 -->
              <div class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-1">2. 노출 시간대 선택</h2>
                <p class="text-sm text-slate-500 mb-4">광고가 노출될 시간대를 선택하세요. (1개만 선택 가능)</p>
                <div class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
                  <button
                    v-for="slot in TIME_SLOTS"
                    :key="slot.id"
                    type="button"
                    @click="selectedTimeSlot = slot"
                    :class="[
                      'p-3 rounded-xl border-2 text-left transition',
                      selectedTimeSlot?.id === slot.id
                        ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-500/20'
                        : 'border-slate-200 hover:border-blue-300 hover:bg-blue-50/50'
                    ]"
                  >
                    <p :class="[
                      'text-sm font-medium',
                      selectedTimeSlot?.id === slot.id ? 'text-blue-700' : 'text-slate-700'
                    ]">{{ slot.label }}</p>
                    <p :class="[
                      'text-xs mt-0.5',
                      selectedTimeSlot?.id === slot.id ? 'text-blue-500' : 'text-slate-400'
                    ]">{{ slot.start }}-{{ slot.end }}</p>
                  </button>
                </div>
              </div>

              <!-- 광고 콘텐츠 입력 -->
              <div class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-4">광고 콘텐츠</h2>

                <!-- 이미지 업로드 -->
                <div class="mb-6">
                  <label class="block text-sm font-medium text-slate-700 mb-2">
                    광고 이미지 <span class="text-red-500">*</span>
                  </label>
                  <div
                    class="relative border-2 border-dashed rounded-xl overflow-hidden transition"
                    :class="imagePreview ? 'border-blue-300' : 'border-slate-300 hover:border-blue-400'"
                  >
                    <input
                      type="file"
                      accept="image/*"
                      @change="handleImageUpload"
                      class="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                    />
                    <div v-if="imagePreview" class="aspect-video">
                      <img :src="imagePreview" class="w-full h-full object-cover" />
                    </div>
                    <div v-else class="aspect-video flex flex-col items-center justify-center text-slate-400">
                      <svg class="w-12 h-12 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                      </svg>
                      <p class="text-sm">이미지를 업로드하세요</p>
                      <p class="text-xs mt-1">권장 비율 16:9</p>
                    </div>
                  </div>
                </div>

                <!-- 배지 텍스트 -->
                <div class="mb-4">
                  <label class="block text-sm font-medium text-slate-700 mb-2">
                    배지 텍스트
                  </label>
                  <input
                    v-model="badge"
                    type="text"
                    maxlength="10"
                    placeholder="예: 특별 혜택, 신규 분양"
                    class="w-full px-4 py-3 border border-slate-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none"
                  />
                  <p class="mt-1 text-xs text-slate-400">최대 10자</p>
                </div>

                <!-- 제목 -->
                <div class="mb-4">
                  <label class="block text-sm font-medium text-slate-700 mb-2">
                    제목 <span class="text-red-500">*</span>
                  </label>
                  <textarea
                    v-model="title"
                    rows="2"
                    maxlength="30"
                    placeholder="광고 제목을 입력하세요"
                    class="w-full px-4 py-3 border border-slate-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none resize-none"
                  ></textarea>
                  <p class="mt-1 text-xs text-slate-400">{{ title.length }}/30자</p>
                </div>

                <!-- 부제목 -->
                <div class="mb-4">
                  <label class="block text-sm font-medium text-slate-700 mb-2">
                    부제목
                  </label>
                  <input
                    v-model="subtitle"
                    type="text"
                    maxlength="40"
                    placeholder="부가 설명을 입력하세요"
                    class="w-full px-4 py-3 border border-slate-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none"
                  />
                  <p class="mt-1 text-xs text-slate-400">최대 40자</p>
                </div>

                <!-- CTA 텍스트 -->
                <div>
                  <label class="block text-sm font-medium text-slate-700 mb-2">
                    버튼 텍스트
                  </label>
                  <input
                    v-model="ctaText"
                    type="text"
                    maxlength="15"
                    placeholder="예: 자세히 보기, 상담 신청"
                    class="w-full px-4 py-3 border border-slate-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none"
                  />
                </div>
              </div>

              <!-- 미리보기 -->
              <div class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-4">미리보기</h2>
                <div class="bg-slate-100 rounded-xl p-4">
                  <div class="bg-white rounded-2xl overflow-hidden shadow-lg max-w-sm mx-auto">
                    <!-- 핸들 -->
                    <div class="flex justify-center py-2">
                      <div class="w-10 h-1 bg-slate-300 rounded-full"></div>
                    </div>
                    <!-- 이미지 -->
                    <div class="aspect-video bg-slate-200 relative">
                      <img v-if="imagePreview" :src="imagePreview" class="w-full h-full object-cover" />
                      <div v-else class="w-full h-full flex items-center justify-center text-slate-400">
                        <span class="text-sm">이미지 미리보기</span>
                      </div>
                      <div class="absolute top-2 left-2 px-2 py-0.5 text-xs font-bold bg-black/60 text-white rounded">AD</div>
                    </div>
                    <!-- 텍스트 -->
                    <div class="p-4">
                      <p v-if="badge" class="inline-block px-2 py-0.5 text-xs font-semibold bg-blue-500 text-white rounded-full mb-2">
                        {{ badge }}
                      </p>
                      <h3 class="font-bold text-slate-800" v-html="formatTitle(title || '제목을 입력하세요')"></h3>
                      <p v-if="subtitle" class="mt-1 text-sm text-slate-500">{{ subtitle }}</p>
                      <div class="mt-3 flex items-center gap-1 text-blue-500 font-semibold text-sm">
                        <span>{{ ctaText || '자세히 보기' }}</span>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                          <path d="M9 18l6-6-6-6"/>
                        </svg>
                      </div>
                    </div>
                    <!-- 버튼 -->
                    <div class="flex border-t border-slate-100 text-sm">
                      <div class="flex-1 py-3 text-center text-slate-400 border-r border-slate-100">오늘 하루 보지 않기</div>
                      <div class="flex-1 py-3 text-center text-slate-600 font-medium">닫기</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 신청 버튼 -->
              <button
                @click="handleSubmit"
                :disabled="!canSubmit || submitting"
                :class="[
                  'w-full py-4 font-semibold rounded-xl transition',
                  canSubmit && !submitting
                    ? 'bg-blue-500 text-white hover:bg-blue-600'
                    : 'bg-slate-200 text-slate-400 cursor-not-allowed'
                ]"
              >
                {{ submitting ? '신청 중...' : '팝업 광고 신청하기 (무료)' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PartnersLayout>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import PartnersLayout from '@/components/partners/common/PartnersLayout.vue'
import PartnersHeader from '@/components/partners/common/PartnersHeader.vue'
import { useAuth } from '@/composables/common/useAuth'
import { usePopupAd } from '@/composables/main/usePopupAd'
import { collection, query, where, getDocs } from 'firebase/firestore'
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'
import { db, storage } from '@/firebase/firebase'

export default {
  name: 'PopupAdPurchaseView',
  components: {
    PartnersLayout,
    PartnersHeader
  },
  setup() {
    const router = useRouter()
    const { user, userProfile } = useAuth()
    const { TIME_SLOTS, applyPopupAd, checkExistingPopupAd } = usePopupAd()

    const loading = ref(true)
    const submitting = ref(false)
    const hasExisting = ref(false)
    const campaigns = ref([])
    const selectedCampaign = ref(null)

    const selectedTimeSlot = ref(null)
    const imageFile = ref(null)
    const imagePreview = ref('')
    const badge = ref('')
    const title = ref('')
    const subtitle = ref('')
    const ctaText = ref('')

    const canSubmit = computed(() => {
      return selectedCampaign.value && selectedTimeSlot.value && imageFile.value && title.value.trim()
    })

    const formatTitle = (text) => {
      if (!text) return ''
      return text.replace(/\n/g, '<br/>')
    }

    const handleImageUpload = (e) => {
      const file = e.target.files[0]
      if (file) {
        imageFile.value = file
        const reader = new FileReader()
        reader.onload = (e) => {
          imagePreview.value = e.target.result
        }
        reader.readAsDataURL(file)
      }
    }

    const loadCampaigns = async () => {
      if (!user.value) return

      try {
        const q = query(
          collection(db, 'campaigns'),
          where('partnerId', '==', user.value.uid),
          where('status', '==', 'active')
        )
        const snapshot = await getDocs(q)

        campaigns.value = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

        // 캠페인이 하나면 자동 선택
        if (campaigns.value.length === 1) {
          selectedCampaign.value = campaigns.value[0]
        }
      } catch (err) {
        console.error('캠페인 로드 실패:', err)
      }
    }

    const handleSubmit = async () => {
      if (!canSubmit.value || submitting.value) return

      submitting.value = true

      try {
        // 이미지 업로드
        const fileName = `popup_${user.value.uid}_${Date.now()}.${imageFile.value.name.split('.').pop()}`
        const fileRef = storageRef(storage, `popupAds/${fileName}`)
        await uploadBytes(fileRef, imageFile.value)
        const imageUrl = await getDownloadURL(fileRef)

        // 팝업 광고 데이터 생성
        const popupData = {
          partnerId: user.value.uid,
          partnerDisplayName: userProfile.value?.name || userProfile.value?.email || '',
          propertyId: selectedCampaign.value.propertyId,
          propertyName: selectedCampaign.value.propertyName,
          campaignId: selectedCampaign.value.id,
          campaignCode: selectedCampaign.value.code,
          timeSlot: selectedTimeSlot.value,
          imageUrl,
          badge: badge.value.trim(),
          title: title.value.trim(),
          subtitle: subtitle.value.trim(),
          ctaText: ctaText.value.trim() || '자세히 보기',
          linkUrl: `/p/${selectedCampaign.value.code}`
        }

        await applyPopupAd(popupData)

        alert('팝업 광고 신청이 완료되었습니다.\n관리자 승인 후 노출됩니다.')
        router.push('/partners/popup/my')
      } catch (err) {
        console.error('신청 실패:', err)
        alert('신청에 실패했습니다: ' + err.message)
      } finally {
        submitting.value = false
      }
    }

    onMounted(async () => {
      loading.value = true

      try {
        // 기존 신청 확인
        if (user.value) {
          hasExisting.value = await checkExistingPopupAd(user.value.uid)
        }

        // 활성 캠페인 로드
        await loadCampaigns()
      } finally {
        loading.value = false
      }
    })

    return {
      loading,
      submitting,
      hasExisting,
      campaigns,
      selectedCampaign,
      TIME_SLOTS,
      selectedTimeSlot,
      imagePreview,
      badge,
      title,
      subtitle,
      ctaText,
      canSubmit,
      formatTitle,
      handleImageUpload,
      handleSubmit
    }
  }
}
</script>

<style scoped>
@reference "tailwindcss";

.spinner {
  @apply w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin;
}
</style>
